import { render, staticRenderFns } from "./WDGCheckbox.vue?vue&type=template&id=7f034f4a&"
import script from "./WDGCheckbox.vue?vue&type=script&lang=js&"
export * from "./WDGCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./WDGCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports